import React from 'react';
import {
    RichCell,
    Button, SplitLayout, SplitCol, Div
} from '@vkontakte/vkui';
import {
    AdaptivityContext
} from "../../assets/constants";


import {
    Icon20AddCircleFillGreen,
    Icon20EditCircleFillBlue,
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import BaseList from "../../components/BaseList";
import StandCollectionsApi from "../../api/references/standcollections";


class StandCollectionsList extends BaseList {

    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);

        console.log(this.state)

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch ?? ''
        }


        StandCollectionsApi.getList(
            {
                search: mainSearch,
                page,
                epp: AdaptivityContext.isMobile ? 10 : 20
            }
        ).then(response => {

            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'brandscollection', id: item.id};
    }

    createItem = () => {
        window.postMessage({
            type: 'setCurrentBrandCollection',
            value: {id: -1}
        })
    }
    getItem = (item) => {
        this.setLastOpenedItem(item.id);
        StandCollectionsApi.getOne(item.id).then(response => {
            const {data} = response

            if (data.id) {
                window.postMessage({type: 'setCurrentBrandCollection', value: data})
            }
        })
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        <Button mode="outline"
                                onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>

                    </Div>
                </SplitCol>

                <SplitCol>
                    <Div>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>


                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }
    renderRow = (item, index) => {
        return <RichCell multiline 
                         style={this.getRowStyle(item)}
                         subhead={<div>
            {(item.kits && item.kits.length)
                ? item.kits.map(kit => `${kit.stand_title} › ${kit.kit_title}`).join('; ')
                : 'Без стенда'}
            {item.deleted ?
                <b>{'[Запрет ввода]'}</b> : ''}
        </div>}
                         afterCaption={<div style={{display: "flex", flexDirection: "column"}}>
                             <Button mode="outline" size="m"
                                     onClick={() => this.getItem(item)}><Icon20EditCircleFillBlue/></Button>
                         </div>
                         }
        >
            {item.title}
        </RichCell>
    }

}

export default StandCollectionsList